<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Sort Lines</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="sortByAlphabetically()">Sort Alphabetically</v-btn>
            <v-btn color="primary" @click="sortByLength()">Sort By Length</v-btn>
            <v-btn color="primary" @click="random()">Random</v-btn>
            <v-btn color="primary" @click="reverse()">Reverse</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: ''
  }),
  computed: {
    lines() {
      return this.text.split('\n')
    }
  },
  methods: {
    sortByAlphabetically() {
      this.result = this.lines.sort().join('\n')
    },
    sortByLength() {
      this.result = this.lines.sort((a, b) => b.length - a.length).join('\n')
    },
    random() {
      let lines = this.lines
      for (let i = lines.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let temp = lines[i]
        lines[i] = lines[j]
        lines[j] = temp
      }
      this.result = lines.join('\n')
    },
    reverse() {
      this.result = this.result
        .split('\n')
        .reverse()
        .join('\n')
    }
  }
}
</script>

<style>
</style>